import React, { useEffect, useState } from "react";
import { useServerList } from "../../hooks/useServerList";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { DataTable } from "./shared";

export default function AutoLogTable({ endpoint, dateLabel, reloadSignal, ...props }) {
  const [filters, setFilters] = useState({});
  const invalidRange = filters.start_date && filters.end_date && filters.start_date > filters.end_date;
  const list = useServerList(endpoint, { initialLimit: 15, filters, sort: "updated_at", dir: "desc" });
  useEffect(() => {
    if (reloadSignal) list.reload();
    // Filter/page changes are already handled by useServerList.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadSignal]);
  const reset = () => { setFilters({}); list.setQ(""); };
  return (
    <div className="min-w-0 space-y-3">
      <div className="flex flex-wrap items-end gap-2">
        {dateLabel && ["start_date", "end_date"].map((key, i) => (
          <label key={key} className="text-xs text-cocoa/70 min-w-0 flex-1 sm:flex-none">
            {dateLabel} · {i === 0 ? "Dari" : "Sampai"} (WIB)
            <Input type="date" className="mt-1 w-full sm:w-44 bg-white" value={filters[key] || ""}
              max={i === 0 ? filters.end_date || undefined : undefined}
              min={i === 1 ? filters.start_date || undefined : undefined}
              onChange={(e) => setFilters((old) => ({ ...old, [key]: e.target.value }))}
              data-testid={`${props.testid}-${key}`} />
          </label>
        ))}
        <Button variant="outline" onClick={reset} data-testid={`${props.testid}-reset`}>Reset filter</Button>
      </div>
      {invalidRange && <p role="alert" className="text-xs text-red-600" data-testid={`${props.testid}-date-error`}>Tanggal akhir tidak boleh sebelum tanggal awal.</p>}
      {dateLabel && <p className="text-xs text-cocoa/60" data-testid={`${props.testid}-date-note`}>
        {dateLabel === "Update Terakhir Desty" ? "Waktu update terakhir di marketplace menurut Desty, bukan tanggal terkirim. " : "Tanggal dibuatnya pesanan di marketplace. "}
        Tanggal diisi saat sinkronisasi Desty berikutnya. Data lama tanpa tanggal ditampilkan sebagai Belum tersedia dan tidak masuk filter tanggal.
      </p>}
      <DataTable {...props} rows={list.items} server={{ ...list, filters, setFilters }} pageSize={list.limit} />
    </div>
  );
}
